/* usp-strip.js - mobile rotation for the USP strip (Productive #272).

   Below 990px the strip has room for ONE message (Figma USPs Property 1=Mobile
   11169:44630 draws a single centred line), so the CSS shows only the first
   item. The client wants the messages to cycle, as the live site's bar does, and
   each to stay clickable. This rotates the items on a timer on small screens;
   on desktop every item is already laid out inline and nothing runs.

   - one owner per strip: [data-usp-rotate] roots, re-initialised on
     shopify:section:load so the editor preview keeps working
   - pauses while hovered / focused (a link you are about to tap must not move)
   - honours prefers-reduced-motion: no auto-advance, the first item stays
   - no strings: the messages are the Liquid-rendered items themselves */
(function () {
	"use strict";

	var MOBILE = "(max-width: 989px)";
	var REDUCED = "(prefers-reduced-motion: reduce)";

	function initStrip(root) {
		if (root.__uspRotator) root.__uspRotator.destroy();
		var items = Array.prototype.slice.call(root.querySelectorAll(".usp-strip__item"));
		if (items.length < 2) return;

		var interval = Math.max(2000, Number(root.getAttribute("data-usp-rotate-interval")) || 4000);
		var index = 0;
		var timer = null;
		var paused = false;
		var mobile = window.matchMedia(MOBILE);
		var reduced = window.matchMedia(REDUCED);

		function show(i) {
			index = (i + items.length) % items.length;
			items.forEach(function (item, n) {
				item.classList.toggle("is-active", n === index);
			});
		}

		function tick() {
			if (paused) return;
			show(index + 1);
		}

		function start() {
			stop();
			if (!mobile.matches || reduced.matches) {
				root.classList.remove("usp-strip--rotating");
				items.forEach(function (item) { item.classList.remove("is-active"); });
				return;
			}
			root.classList.add("usp-strip--rotating");
			show(index);
			timer = window.setInterval(tick, interval);
		}

		function stop() {
			if (timer) window.clearInterval(timer);
			timer = null;
		}

		var onEnter = function () { paused = true; };
		var onLeave = function () { paused = false; };
		var onVisibility = function () { paused = document.hidden; };

		root.addEventListener("mouseenter", onEnter);
		root.addEventListener("mouseleave", onLeave);
		root.addEventListener("focusin", onEnter);
		root.addEventListener("focusout", onLeave);
		document.addEventListener("visibilitychange", onVisibility);
		var onMedia = function () { start(); };
		if (mobile.addEventListener) { mobile.addEventListener("change", onMedia); reduced.addEventListener("change", onMedia); }
		else { mobile.addListener(onMedia); reduced.addListener(onMedia); }

		root.__uspRotator = {
			destroy: function () {
				stop();
				root.removeEventListener("mouseenter", onEnter);
				root.removeEventListener("mouseleave", onLeave);
				root.removeEventListener("focusin", onEnter);
				root.removeEventListener("focusout", onLeave);
				document.removeEventListener("visibilitychange", onVisibility);
				if (mobile.removeEventListener) { mobile.removeEventListener("change", onMedia); reduced.removeEventListener("change", onMedia); }
				else { mobile.removeListener(onMedia); reduced.removeListener(onMedia); }
				root.classList.remove("usp-strip--rotating");
				root.__uspRotator = null;
			},
		};

		start();
	}

	function initAll(scope) {
		(scope || document).querySelectorAll("[data-usp-rotate]").forEach(initStrip);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () { initAll(); });
	} else {
		initAll();
	}
	document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
